import { format } from 'date-fns'
import { DateRange } from 'react-day-picker'
import { DatePickerMode } from '../../types/dataPicker'

export const formatDateValue = (
  mode: DatePickerMode,
  value: Date | DateRange | Date[] | undefined,
  placeholder: string,
): string => {
  if (mode === 'single') {
    return value ? format(value as Date, 'PPP') : placeholder
  }

  if (mode === 'range') {
    const range = value as DateRange
    if (!range?.from) return placeholder
    if (!range.to) return format(range.from, 'PPP')

    return `${format(range.from, 'MMM dd')} - ${format(range.to, 'MMM dd, yyyy')}`
  }

  if (mode === 'multiple') {
    const dates = value as Date[]
    if (!dates || dates.length === 0) return placeholder
    if (dates.length === 1) return format(dates[0], 'PPP')
    if (dates.length === 2) {
      return `${format(dates[0], 'MMM dd')}, ${format(dates[1], 'MMM dd')}`
    }
    return `${dates.length} dates selected`
  }

  return placeholder
}

export const getInitialDisplayMonth = (
  mode: DatePickerMode,
  value: Date | DateRange | Date[] | undefined,
): Date => {
  if (mode === 'single') {
    return (value as Date) || new Date()
  }
  if (mode === 'range') {
    return (value as DateRange)?.from || new Date()
  }
  if (mode === 'multiple') {
    const dates = value as Date[]
    return dates && dates.length > 0 ? dates[0] : new Date()
  }
  return new Date()
}

export const hasValidSelection = (
  mode: DatePickerMode,
  tempValue: Date | DateRange | Date[] | undefined,
): boolean => {
  if (mode === 'single') {
    return !!tempValue
  }
  if (mode === 'range') {
    return !!(tempValue as DateRange)?.from
  }
  if (mode === 'multiple') {
    const dates = tempValue as Date[]
    return !!(dates && dates.length > 0)
  }
  return false
}

export const getContentWidth = (
  mode: DatePickerMode,
  numberOfMonths: number,
): string => {
  return mode === 'range' && numberOfMonths === 2
    ? 'max-w-[670px]'
    : 'max-w-[330px]'
}
